var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      staticClass: "ns-credit-card-form",
      attrs: { "lazy-validation": "" }
    },
    [
      _c("h2", [
        _c("span", { staticClass: "title-small-bold" }, [
          _vm._v(_vm._s(_vm.t.cedynaFormTitle))
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "secure" },
          [
            _c("NsIcon", { attrs: { "icon-name": "icon-lock" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.t.secure))])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("NsCreditCard", {
        attrs: {
          "payment-type-id": _vm.value.paymentTypeId,
          "available-payments": _vm.paymentOptions,
          translations: _vm.t.creditCard
        },
        on: {
          input: _vm.updateCardNumber,
          paymentTypeId: _vm.updatePaymentTypeId
        },
        model: {
          value: _vm.value.cardNumber,
          callback: function($$v) {
            _vm.$set(_vm.value, "cardNumber", $$v)
          },
          expression: "value.cardNumber"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }